import { apiConf as api } from "commons";

export const createEtude = (payload) => {
  return api.superFetch({
    url: `etudes`,
    method: "POST",
    body: payload,
  });
};
